import { DialogTrigger } from "@indietabletop/appkit";
import {
  MoreMenu,
  MoreMenuDialogDisclosure,
  MoreMenuSeparator,
} from "../ActionsMenu/ActionsMenu";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog";
import { database } from "../database/database";
import { KnightContext, useKnight } from "./KnightContext";
import { useIsReadOnly } from "./ReadOnlyContext";
import { useKnightResult } from "./useWarbandContext";

function DuplicateKnight() {
  const knight = useKnight();

  return (
    <ConfirmDialog
      heading="Duplicate knight?"
      description={`A new knight matching ${knight.name} will be created.`}
      submitLabel="Duplicate"
      onSubmit={async () => {
        const { warband, id: knightId } = knight.duplicate();
        const result = await database.warbands.updateOne(warband.data);
        return result.mapSuccess(() => ({ navigateTo: `/k/${knightId}` }));
      }}
    />
  );
}

function DeleteKnight() {
  const knight = useKnight();

  return (
    <ConfirmDialog
      heading="Delete knight?"
      description={`${knight.name} will be deleted. You cannot undo this.`}
      submitLabel="Delete"
      submitTheme="red"
      onSubmit={async () => {
        const warband = knight.warband.removeKnight(knight.id);
        const result = await database.warbands.updateOne(warband.data);
        return result.mapSuccess(() => ({ navigateTo: `/` }));
      }}
    />
  );
}

export function KnightMenu() {
  const result = useKnightResult();
  const isReadOnly = useIsReadOnly();

  if (!result.isSuccess || isReadOnly) {
    return null;
  }

  return (
    <KnightContext value={result.value}>
      <MoreMenu>
        {/* <DialogTrigger>
          <EditWarbandDialog />
          <MoreMenuDialogDisclosure>Rename</MoreMenuDialogDisclosure>
        </DialogTrigger> */}

        <DialogTrigger>
          <DuplicateKnight />
          <MoreMenuDialogDisclosure>Duplicate</MoreMenuDialogDisclosure>
        </DialogTrigger>

        <MoreMenuSeparator />

        <DialogTrigger>
          <DeleteKnight />
          <MoreMenuDialogDisclosure>Delete</MoreMenuDialogDisclosure>
        </DialogTrigger>
      </MoreMenu>
    </KnightContext>
  );
}
